/**
 * Samweb WebClient
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DirectoryAddEntryRequestData } from '../model/directoryAddEntryRequestData';
import { DirectoryDeleteEntryRequestData } from '../model/directoryDeleteEntryRequestData';
import { DirectoryEditEntryRequestData } from '../model/directoryEditEntryRequestData';
import { DirectoryEntrySearchResponse } from '../model/directoryEntrySearchResponse';
import { DirectoryOrganisationsResponse } from '../model/directoryOrganisationsResponse';
import { DirectoryQueryEmailResponse } from '../model/directoryQueryEmailResponse';
import { DirectoryReverseNameLookupResponse } from '../model/directoryReverseNameLookupResponse';
import { DirectorySearchResponse } from '../model/directorySearchResponse';
import { DirectoryStructureResponse } from '../model/directoryStructureResponse';
import { QueryDirectoryEmailRequestData } from '../model/queryDirectoryEmailRequestData';
import { QueryDirectoryEntryRequestData } from '../model/queryDirectoryEntryRequestData';
import { QueryDirectoryRequestData } from '../model/queryDirectoryRequestData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class DirectoriesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDirectoryEntry(body?: DirectoryAddEntryRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addDirectoryEntry(body?: DirectoryAddEntryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addDirectoryEntry(body?: DirectoryAddEntryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addDirectoryEntry(body?: DirectoryAddEntryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/directories/add-directory-entry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDirectoryEntry(body?: DirectoryDeleteEntryRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteDirectoryEntry(body?: DirectoryDeleteEntryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteDirectoryEntry(body?: DirectoryDeleteEntryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteDirectoryEntry(body?: DirectoryDeleteEntryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/directories/delete-directory-entry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public directoryOrganisationData(observe?: 'body', reportProgress?: boolean): Observable<DirectoryOrganisationsResponse>;
    public directoryOrganisationData(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectoryOrganisationsResponse>>;
    public directoryOrganisationData(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectoryOrganisationsResponse>>;
    public directoryOrganisationData(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DirectoryOrganisationsResponse>('get',`${this.basePath}/api/directories/directory-organisation-data`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public directoryStructure(observe?: 'body', reportProgress?: boolean): Observable<DirectoryStructureResponse>;
    public directoryStructure(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectoryStructureResponse>>;
    public directoryStructure(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectoryStructureResponse>>;
    public directoryStructure(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DirectoryStructureResponse>('get',`${this.basePath}/api/directories/directory-structure`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editDirectoryEntry(body?: DirectoryEditEntryRequestData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public editDirectoryEntry(body?: DirectoryEditEntryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public editDirectoryEntry(body?: DirectoryEditEntryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public editDirectoryEntry(body?: DirectoryEditEntryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/directories/edit-directory-entry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryDirectory(body?: QueryDirectoryRequestData, observe?: 'body', reportProgress?: boolean): Observable<DirectorySearchResponse>;
    public queryDirectory(body?: QueryDirectoryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectorySearchResponse>>;
    public queryDirectory(body?: QueryDirectoryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectorySearchResponse>>;
    public queryDirectory(body?: QueryDirectoryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DirectorySearchResponse>('post',`${this.basePath}/api/directories/query-directory`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryDirectoryEmail(body?: QueryDirectoryEmailRequestData, observe?: 'body', reportProgress?: boolean): Observable<DirectoryQueryEmailResponse>;
    public queryDirectoryEmail(body?: QueryDirectoryEmailRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectoryQueryEmailResponse>>;
    public queryDirectoryEmail(body?: QueryDirectoryEmailRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectoryQueryEmailResponse>>;
    public queryDirectoryEmail(body?: QueryDirectoryEmailRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DirectoryQueryEmailResponse>('post',`${this.basePath}/api/directories/query-directory-email`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryDirectoryEntry(body?: QueryDirectoryEntryRequestData, observe?: 'body', reportProgress?: boolean): Observable<DirectoryEntrySearchResponse>;
    public queryDirectoryEntry(body?: QueryDirectoryEntryRequestData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectoryEntrySearchResponse>>;
    public queryDirectoryEntry(body?: QueryDirectoryEntryRequestData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectoryEntrySearchResponse>>;
    public queryDirectoryEntry(body?: QueryDirectoryEntryRequestData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<DirectoryEntrySearchResponse>('post',`${this.basePath}/api/directories/query-directory-entry`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public reverseNameLookup(phoneNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<DirectoryReverseNameLookupResponse>;
    public reverseNameLookup(phoneNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DirectoryReverseNameLookupResponse>>;
    public reverseNameLookup(phoneNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DirectoryReverseNameLookupResponse>>;
    public reverseNameLookup(phoneNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<DirectoryReverseNameLookupResponse>('get',`${this.basePath}/api/directories/reverse-name-lookup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
